import React, { useEffect, useState } from 'react'
import { Box, makeStyles } from '@material-ui/core'
import { Button, Loading, Modal } from '../../root/components/common'
import { CustomInputWithButton } from '../../root/components/common/input-with-button'

export const AddSimCardModal = ({
    locale,
    simCardSerialNumber,
    setSimCardSerialNumber,
    simCardError,
    setSimCardError,
    handleCancelSimCard,
    handleSaveSimCard,
    isCreatingSimCard,
    isSimCardCreationSuccessful,
    isSimCardCreationError
}) => {
    const [isOpen, setIsOpen] = useState(false)
    const classes = useStyles()

    const handleClose = () => {
        setIsOpen(false)
    }

    const openModal = () => {
        setSimCardSerialNumber('')
        setSimCardError('')
        setIsOpen(true)
    }

    useEffect(() => {
        if (isSimCardCreationSuccessful) {
            setSimCardSerialNumber('')
            setIsOpen(false)
        }
    }, [isSimCardCreationSuccessful])

    return (
        <>
            <Button onClick={openModal}>
                {locale.simCards.addSimCardLabel}
            </Button>
            <Modal open={isOpen} onClose={handleClose}>
                {isCreatingSimCard ? (
                    <Loading />
                ) : (
                    <Box className={classes.wrapper}>
                        <CustomInputWithButton
                            label={locale.simCards.simCardSerialNumber}
                            value={simCardSerialNumber}
                            onChange={setSimCardSerialNumber}
                            btnLabel={locale.common.save}
                            handleCancelClick={handleCancelSimCard}
                            handleBtnClick={handleSaveSimCard}
                            errorText={simCardError}
                            isError={!!simCardError}
                        />
                    </Box>
                )}
            </Modal>
        </>
    )
}

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        gap: 20
    }
}))
